import ApiService from '@/services/api.service.js';

export const ExportService =
{
    exportAwarded: function (data)
    {
        return ApiService.post('/export/awarded', data);
    },
}

export default ExportService
